import React from "react";

const BasicInfoForm = ({ formData, handleChange }) => {
  return (
    <>
      <div className="form-group">
        <label>Name</label>
        <input
          name="name"
          type="text"
          placeholder="Your full name"
          value={formData.name}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Email ID</label>
        <input
          name="email"
          type="email"
          placeholder="your.email@example.com"
          value={formData.email}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Phone Number</label>
        <input
          name="phone"
          type="text"
          placeholder="Enter phone number"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>

    </>
  );
};

export default BasicInfoForm;
